import React, { Component } from "react"
import "./Footer.scss"
import i18n from "../../../i18n";
import { Trans } from "react-i18next";
import OneButtonDialog from "../../OneButtonDialog/OneButtonDialog"

import { connect } from 'react-redux'
import { REDUX_ACTION } from '../../../Redux/action'
import { ReduxBinding } from '@/Redux/instance'
import { MOBILE_ROUTE_PATH } from "@/utils/Global";
import SlideUpDialog from "@/_mobile/Common/SlideUpDialog";

class Footer extends Component {
    state = {
        oneButtonDialog: {
            isDialogOpen: false,
            dialogBodyText1: null,
            dialogBodyText2: null,
            dialogButtonText: null,
            onClose: null,
            onButtonClick: null,
        },
        isAiToolsDialogOpen: false,
        isDesignSelectDialogOpen: false
    }

    handleDialogClose = () => {
        const { oneButtonDialog } = this.state
        oneButtonDialog.isDialogOpen = false
        this.setState({ oneButtonDialog })
    }

    handleUpcomingDialogOpen = () => {
        this.setState({
            oneButtonDialog: {
                isDialogOpen: true,
                dialogBodyText1: i18n.t("mobile.global.upcoming"),
                onClose: this.handleDialogClose,
                onButtonClick: this.handleDialogClose
            }
        })
    }

    handleAiToolsDialogClose = () => {
        this.setState({ isAiToolsDialogOpen: false })
    }

    handleDesignSelectDialogClose = () => {
        this.setState({ isDesignSelectDialogOpen: false })
    }

    handleNavItemClick = router => () => {
        if (router === MOBILE_ROUTE_PATH.AI_TOOLS) {
            this.setState({ isAiToolsDialogOpen: true })
            return
        } else if (router === MOBILE_ROUTE_PATH.DESIGN_SELECT) {
            this.setState({ isDesignSelectDialogOpen: true })
            return
        }

        if (router === '/myVideo') {
            ReduxBinding(REDUX_ACTION.MY_VIDEO_STATE, null)
            ReduxBinding(REDUX_ACTION.MY_SHORTS_STATE, null)
        }
        else if (router === '/gallery') ReduxBinding(REDUX_ACTION.GALLERY_STATE, null)

        this.props.history.push(router)
    }

    handleAiToolsClick = () => {
        this.handleAiToolsDialogClose()
        this.props.history.push(MOBILE_ROUTE_PATH.AI_TOOLS)
    }

    handleImageToVideoClick = () => {
        this.handleAiToolsDialogClose()
        this.props.history.push(MOBILE_ROUTE_PATH.AI_TOOLS_IMAGE_TO_VIDEO)
    }

    handleTemplateClick = () => {
        this.handleDesignSelectDialogClose()
        this.props.history.push(MOBILE_ROUTE_PATH.DESIGN_SELECT)
    }

    handleUrlShortsClick = () => {
        this.handleDesignSelectDialogClose()
        this.props.history.push(MOBILE_ROUTE_PATH.YOUTUBE_SHORTS)
    }

    render() {
        const { pathname } = this.props.history.location;
        const { theme } = this.props
        const { isAiToolsDialogOpen, isDesignSelectDialogOpen } = this.state
		
        return (
            <>
                <div className={`footer-container`}>
                    <div onClick={this.handleNavItemClick(MOBILE_ROUTE_PATH.AI_TOOLS)} >
                        <img
                            className="footer-img"
                            src={
                                pathname === MOBILE_ROUTE_PATH.AI_TOOLS || 
                                pathname === MOBILE_ROUTE_PATH.AI_TOOLS_IMAGE_TO_VIDEO
                                    ? "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/ai-tools-active.svg"
                                    : "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/ai-tools.svg"
                            }
                            alt="aiIcon"
                        />
                        <span
                            className={
                                pathname === MOBILE_ROUTE_PATH.AI_TOOLS ||
                                pathname === MOBILE_ROUTE_PATH.AI_TOOLS_IMAGE_TO_VIDEO
                                    ? "active"
                                    : ""
                            }
                        >
                            {i18n.t("common.header.ai")}
                        </span>
                    </div>
                    <div
                        onClick={this.handleNavItemClick(MOBILE_ROUTE_PATH.WORKSPACE)}
                    >
                        <img
                            className="footer-img"
                            src={
                                pathname === MOBILE_ROUTE_PATH.WORKSPACE
                                    ? "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/workspace-active.svg"
                                    : "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/workspace.svg"
                            }
                            alt="worksapceIcon"
                        />
                        <span
                            className={
                                pathname === MOBILE_ROUTE_PATH.WORKSPACE
                                    ? "active"
                                    : ""
                            }
                        >
                            {i18n.t("common.header.workspace")}
                        </span>
                    </div>
                    <div className="footer-main-button-container" onClick={this.handleNavItemClick(MOBILE_ROUTE_PATH.DESIGN_SELECT)}>
                        <div className="footer-main-button">
                            <img
                                className="footer-img"
                                src={
                                    pathname === MOBILE_ROUTE_PATH.DESIGN_SELECT_LIST ||
                                        pathname === MOBILE_ROUTE_PATH.DESIGN_SELECT ||
                                        pathname === MOBILE_ROUTE_PATH.YOUTUBE_SHORTS
                                        ? "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/new-project-active.svg"
                                        : "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/new-project.svg"
                                }
                                alt="makeIcon"
                            />
                            <span
                                className={
                                    pathname === MOBILE_ROUTE_PATH.DESIGN_SELECT_LIST ||
                                        pathname === MOBILE_ROUTE_PATH.DESIGN_SELECT ||
                                        pathname === MOBILE_ROUTE_PATH.YOUTUBE_SHORTS
                                        ? "active"
                                        : ""
                                }
                            >
                                {i18n.t("common.header.new.project")}
                            </span>
                        </div>
                    </div>
                    <div onClick={this.handleNavItemClick(MOBILE_ROUTE_PATH.SHOP)}>
                        <img
                            className="footer-img"
                            src={
                                pathname === MOBILE_ROUTE_PATH.SHOP
                                    ? "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/price-active.svg"
                                    : "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/price.svg"
                            }
                            alt="pricingIcon"
                        />
                        <span
                            className={
                                pathname === MOBILE_ROUTE_PATH.SHOP ? "active" : ""
                            }
                        >
                            {i18n.t("mobile.mypage.shop.btn")}
                        </span>
                    </div>
                    <div
                        onClick={this.handleNavItemClick(MOBILE_ROUTE_PATH.MY_VIDEO)}
                    >
                        <img
                            className="footer-img"
                            src={
                                pathname === MOBILE_ROUTE_PATH.MY_VIDEO
                                    ? "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/my-video-active.svg"
                                    : "https://front.videomonster.com/images-u6yd72dy/mobile/v2/footer-menu/my-video.svg"
                            }
                            alt="myVideoIcon"
                        />
                        <span
                            className={
                                pathname === MOBILE_ROUTE_PATH.MY_VIDEO
                                    ? "active"
                                    : ""
                            }
                        >
                            {i18n.t("mobile.myvideo.title")}
                        </span>
                    </div>

                    <OneButtonDialog
                        onClose={this.state.oneButtonDialog.onClose}
                        open={this.state.oneButtonDialog.isDialogOpen}
                        onButtonClick={
                            this.state.oneButtonDialog.onButtonClick
                        }
                        dialogBodyText1={
                            this.state.oneButtonDialog.dialogBodyText1
                        }
                        dialogButtonText={
                            this.state.oneButtonDialog.dialogButtonText
                        }
                    />
                </div>

                <SlideUpDialog
                    isOpen={isAiToolsDialogOpen}
                    onClose={this.handleAiToolsDialogClose}
                >
                    <div className="footer-slide-up-dialog-container">
                        <div className="footer-slide-up-dialog-title">
                            <Trans i18nKey="mobile.menu.ai.tools.des" ><span className="hight-light" /></Trans>
                        </div>
                        <div className="footer-slide-up-dialog-item" onClick={this.handleAiToolsClick}>
                            <div><img src="https://front.videomonster.com/images-u6yd72dy/common/ai/icons/1-ai-tools-white.svg" /></div>
                            <span>{i18n.t("common.header.ai")}</span>
                        </div>
                        <div className="footer-slide-up-dialog-title">
                            <Trans i18nKey="mobile.menu.image.to.video.des" ><span className="hight-light" /></Trans>
                        </div>
                        <div className="footer-slide-up-dialog-item" onClick={this.handleImageToVideoClick}>
                            <div><img src="https://front.videomonster.com/images-u6yd72dy/common/ai/icons/1-video-gen-white.svg" /></div>
                            <span>Image to Video</span>
                        </div>
                    </div>
                </SlideUpDialog>

                <SlideUpDialog
                    isOpen={isDesignSelectDialogOpen}
                    onClose={this.handleDesignSelectDialogClose}
                >
                    <div className="footer-slide-up-dialog-container">
                        <div className="footer-slide-up-dialog-title">
                            <Trans i18nKey="mobile.menu.make.by.template.des" ><span className="hight-light-2" /></Trans>
                        </div>
                        <div className="footer-slide-up-dialog-item" onClick={this.handleTemplateClick}>
                            <div><img src="https://front.videomonster.com/images-u6yd72dy/common/ai/icons/video-template-white.svg" /></div>
                            <span>{i18n.t("mobile.menu.make.by.template")}</span>
                        </div>
                        <div className="footer-slide-up-dialog-title">
                            <Trans i18nKey="mobile.menu.make.by.url.des" ><span className="hight-light-2" /></Trans>
                        </div>
                        <div className="footer-slide-up-dialog-item" onClick={this.handleUrlShortsClick}>
                            <div><img src="https://front.videomonster.com/images-u6yd72dy/common/ai/icons/url-to-video-white.svg" /></div>
                            <span>
                                {i18n.t("mobile.menu.make.by.url")}
                                {/* <div className="coming-soon">Coming Soon</div> */}
                            </span>
                        </div>
                    </div>
                </SlideUpDialog>
            </>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang,
    theme: state.themeStore.theme
})

export default connect(mapStateToProps, null)(Footer)